import { api, ApiError } from "@/api/api";
import { CreatePromptRevision, PromptRevision } from "@/api/prompts-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Variables = {
  promptId: string;
  data: CreatePromptRevision;
};

export function useCreatePromptRevision() {
  const queryClient = useQueryClient();
  return useMutation<PromptRevision, ApiError, Variables>({
    mutationKey: ["POST", "prompts", "revisions"],
    mutationFn: ({ promptId, data }) =>
      api.prompts.promptId.revisions.post(promptId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["GET", "promptDetails", variables.promptId],
      });
      queryClient.invalidateQueries({ queryKey: ["GET", "prompts"] });
    },
  });
}
